export const prepareWhatsappNumber = (number) =>
  number.replaceAll(" ", "").replaceAll("+", "");
